
<template>
    <div class="center examplex">
        <vs-row class="pt-3 pb-3">
            <vs-col class="widthCard" v-if="prospectos_total">
                <md-card class="text-center md-warn" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{prospectos_total.number}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">Prospectos</h4>
                            <p class="mb-0">Número total de prospectos</p>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col class="widthCard" v-if="interesados">
                <md-card class="text-center md-info" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{interesados.number}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">En proceso de admisión</h4>
                            <p class="mb-0">Prospecto, Interesado y Aplicante</p>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
            <vs-col class="widthCard" v-if="inscriptos">
                <md-card class="text-center md-succes" md-with-hover>
                    <md-ripple>
                        <md-card-header>
                        <div class="md-title">
                            <strong>{{inscriptos.number}}</strong>
                        </div>
                        <div class="md-subhead">
                            <h4 class="mb-0">Admitidos</h4>
                            <p class="mb-0">Admitido, inscrito económico y académico.</p>
                        </div>
                        </md-card-header>
                    </md-ripple>
                </md-card>
            </vs-col>
        </vs-row>
        <vs-table striped>
            <template #thead>
            <vs-tr>
                <vs-th style="width: 150px !important;">
                    Canal de obtención
                </vs-th>
                <vs-th style="width: 30px !important;">
                    ID
                </vs-th>
                <vs-th>
                    Nombre
                </vs-th>
                <vs-th>
                    Datos de contacto
                </vs-th>
                <vs-th>
                    Escuela de procedencia
                </vs-th>
                <vs-th>
                    Oferta académica
                </vs-th>
                <vs-th>
                    Estatus
                </vs-th>
                <vs-th>
                    Acciones
                </vs-th>
            </vs-tr>
            </template>
            <template #tbody>
            <vs-tr
                :key="i"
                v-for="(tr, i) in users"
                :data="tr"
            >
                <vs-td>
                    <md-chip :class="`mini-chip ` + origin_color[tr.proceso_admision.origen]['color']" ><strong> <small class="text-uppercase"> {{origin_color[tr.proceso_admision.origen]['text']}}</small></strong></md-chip>
                    <p class="text-uppercase"><strong>{{tr.proceso_admision.tracking_code}}</strong></p>
                </vs-td>
                <vs-td>
                    {{tr.id}}
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{ tr.fullName }}</strong></p>
                </vs-td>
                <vs-td>
                    <div v-if="tr.familiares[0]">
                        <div v-for="(familiar, i) in tr.familiares" :key="i" >
                            <div :style="tr.familiares.length > 1 ? 'border-bottom: 1px solid ##CACFD2' : ''">
                                <p class="mb-0"><strong>{{familiar.fullName}}</strong></p>
                                <p v-if="familiar.celular" class="mb-0"><i class="fas fa-mobile-alt mr-1"></i> {{familiar.celular}}</p>
                                <p v-if="familiar.telefono_casa" class="mb-0"><i class="fas fa-home mr-1"></i> {{familiar.telefono_casa}}</p>
                                <p v-if="familiar.correo" class="mb-0"><i class="far fa-envelope mr-1"></i>{{familiar.correo}}</p>
                            </div>
                        </div>
                    </div>
                    <div v-else>
                        <p>No hay información</p>
                    </div>
                </vs-td>
                <vs-td>
                    <p v-if="tr.proceso_admision.escuela_procedencia"><strong>{{tr.proceso_admision.escuela_procedencia.nombre}}</strong> ( {{tr.proceso_admision.escuela_procedencia.ciudad}} )</p>
                </vs-td>
                <vs-td>
                    <p class="mb-0"><strong>{{tr.proceso_admision.oferta_academica.programa.nombre}}</strong></p>
                    <p class="mb-0"><small>{{tr.proceso_admision.oferta_academica.nombre}}</small></p>
                </vs-td>
                <vs-td>
                    <md-chip :class="'mini-chip ' + coloresEstatus(tr.proceso_admision.status.id)" ><strong> {{ tr.proceso_admision.status.status }} </strong></md-chip>
                </vs-td>
                <vs-td>
                    <md-menu md-size="medium" md-align-trigger>
                        <md-button md-menu-trigger><i class="fas fa-ellipsis-v"></i></md-button>

                        <md-menu-content>
                            <md-menu-item v-if="permisos" @click="activeEditar =! activeEditar; infoRow = tr; ">Modificar</md-menu-item>
                            <md-menu-item :href="'panel/seguimiento/'+window.btoa(tr.id)+'/institucion/'+window.btoa(tr.proceso_admision.oferta_academica.institucion_id)" target="_blank">Ir a perfil</md-menu-item>
                        </md-menu-content>
                    </md-menu>
                </vs-td>
            </vs-tr>
            </template>
            <template #footer>
                <vs-pagination  v-model="page" :length="pages" />           
            </template>
            <template #notFound>
                No hay información
            </template>
        </vs-table>
        <editar  v-model="activeEditar" :row="infoRow" :institucionSelect="institucionSelect" :instituciones="instituciones" :ciclo="ciclo" @refreshTable="getProspectos"></editar>
    </div>
</template>
<script>
import admisiones from '../../../../api/requests/admisiones.js'
import editar from './modales/editar.vue'
export default {
    props: [
        'parametros',
        'ejecutar',
        'institucionSelect',
        'instituciones',
        'ciclo',
        'permisos'
    ],
    data:() => ({
        users: [],
        estatusColor: {
            'Prospecto': {
                'color': 'purple'
            },
            'Interesado': {
                'color': 'brown'
            },
            'Aplicante': {
                'color': 'blue'
            },
            'Admitido': {
                'color': 'green'
            },
            'Inscrito económico': {
                'color': 'blue'
            },
            'Congelado': {
                'color': 'pink'
            },
            'Descartado': {
                'color': 'pink'
            },
            'Inscrito académico': {
                'color': 'yellow'
            },
            'Acreditado en ciclo escolar': {
                'color': 'green'
            },
            'No acreditado en ciclo escolar': {
                'color': 'pink'
            },
            'Baja definitiva voluntaria': {
                'color': 'gray'
            },
            'Baja definitiva por conducta': {
                'color': 'gray'
            },
            'Baja temporal voluntaria': {
                'color': 'gray'
            },
            'Suspensión por morosidad': {
                'color': 'red'
            },
            'Bloqueo para inscripción': {
                'color': 'red'
            },
            'Reactivación': {
                'color': 'blue'
            },
        },
        origin_color: {
            'landing_marketing': {
                color: 'col-marketing',
                text: 'Landing marketing'
            },
            'modulo_prospectos': {
                color: 'col-prospectos',
                text: 'Módulo prospectos'
            },
            'migracion_interna': {
                color: 'col-blue',
                text: 'Migración interna'
            },
            'crm_oracle':{
                color: 'col-oracle',
                text: 'CRM ORACLE'
            },
        },
        page: 1, 
        max: 10,
        pages: 0,
        prospectos_total: '',
        interesados: '',
        inscriptos: '',
        infoRow: [],
        activeEditar: false
    }),
    components:{
        editar
    },
    methods:{
        coloresEstatus(id){
            console.log(id)
            if([5,16].includes(id)){
                return 'col-green'
            }else if([6].includes(id)){
                return 'col-yellow'
            }else if([11, 12, 13, 14, 17, 18, 19, 20, 21, 22, 23, 24, 25, 26].includes(id)){
                return 'col-red'
            }else{
                return 'col-blue'
            }
        },
        origin_color(){

        },
        getProspectos(){
            this.$emit('refreshTable')
        },
        getParametros(){
            const params = {
                institucion_id: this.parametros.institucion,
                ciclo_escolar_id: this.parametros.cicloEscolar
            }
            if(this.parametros.oferta != ''){
                params.oferta_academica_id = this.parametros.oferta
            }
            if(this.parametros.estatus != ''){
                params.status_id = this.parametros.estatus
            }
            if(this.parametros.nombre != ''){
                params.nombres = this.parametros.nombre
            }
            if(this.parametros.grupo != ''){
                params.grupo = this.parametros.grupo
            }
            
            if(this.parametros.origen){
                params.origen = this.parametros.origen
            }
            return params
        },
        async getProspectosTotal(){
            try {
                const params = this.getParametros()
                const {data: response} = await admisiones.getProspectosTotal(params)
                this.prospectos_total = response
            }
            catch{

            }
        },
        async getProspectosInteresados(){
            try {
                const params = this.getParametros()
                const {data: response} = await admisiones.getProspectosInteresados(params)
                this.interesados = response
            }
            catch{
            }
        },
        async getProspectosInscriptos(){
            try {
                const params = this.getParametros()
                const {data: response} = await admisiones.getProspectosInscriptos(params)
                this.inscriptos = response
            }
            catch{

            }
        },
        async getProspectos(){
                const loading = this.$vs.loading()
            try {
                const params = this.getParametros()
                params.page = this.page
                const {data: response} = await admisiones.getProspectos(params)
                loading.close()
                const { data: dataTable = [], per_page = 20, total = 0 } = response|| {}
                this.pages = Math.ceil(total/per_page) || 0
                this.users = dataTable
            }
            catch{
                loading.close()

            }
        }
    },
    watch:{
        ejecutar(){
            this.getProspectosTotal()
            this.getProspectosInteresados()
            this.getProspectosInscriptos()
            this.getProspectos()
        },
        page(){
            this.getProspectos()
        }
    }
}
</script>


<style scoped>
    .col-yellow{
        background: rgb(255, 248, 236);
        color: #febf3d;
    }

    .col-red{
        color: #f62d51;
        background: rgb(249, 231, 235);
    }

    .col-green{
        color: #55ce63;
        background: rgb(232, 253, 235);
    }

    .col-purple{
        color: purple;
        background: rgb(232, 218, 239);
    }

    .col-blue{
        color: #2874A6;
        background: rgb(214, 234, 248);
    }

    .col-gray{
        color: #5F6A6A;
        background: rgb(242, 243, 244);
    }

    .col-pink{
        color: #F08080;
        background: rgb(255, 236, 236);
    }

    .col-brown{
        color: #784212;
        background: rgb(250, 229, 211);
    }
    .col-marketing{
        color: #D30096;
        background: rgb(255, 239, 250);
    }
    .col-prospectos{
        color: #00B59A;
        background: rgb(225, 241, 238);
    }
    .col-oracle{
        color: #ca6f1e;
        background: rgb(250, 229, 211);
    }
</style>

<style scoped>
.md-warn{
    background: #ffbc34;
    color: white;
    border-radius: 7px;
}

.widthCard{
    width: 30%;
    margin: 0 1.5%;
    @media only screen and (max-width: 768px) {
        width: 47%;
        margin: 1.5%;
    }
}

.md-succes{
    background: #28a745;
    color: white;
    border-radius: 7px;
}

.md-info{
    background: #9e16aa;
    color: white;
    border-radius: 7px;
}
</style>

        